/*
 * Kroneks cart add-ons (snippets/kr-cart-xsell.liquid), 2026-10-22.
 *
 * The same block sits in the cart drawer (computers) and on the /cart page (phones
 * land there). "Добави" puts the add-on in the cart and redraws, from that one
 * response (Section Rendering API), every cart fragment on the page: the drawer,
 * the /cart page products + totals and the cart icon count. The free delivery
 * bar, the totals and the offer list therefore update in one step.
 *
 * The cart fragments are replaced on every cart change, so the listener sits on
 * document and this file loads from layout/theme.liquid, never from inside them.
 */
(function () {
  if (window.krCartXsell) return;
  window.krCartXsell = true;

  function addUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  // The /cart page fragments cart.js redraws (sections/main-cart-items + main-cart-footer).
  function pageSections() {
    return ['main-cart-items', 'main-cart-footer']
      .map(function (id) {
        var el = document.getElementById(id);
        return el && el.dataset.id ? { el: el, section: el.dataset.id } : null;
      })
      .filter(Boolean);
  }

  function markAdded(root, variantId) {
    var input = root && root.querySelector('[data-quantity-variant-id="' + variantId + '"]');
    var row = input && input.closest('.cart-item');
    if (!row) return;
    row.classList.add('kr-cd-added');
    row.addEventListener('animationend', function () {
      row.classList.remove('kr-cd-added');
    }, { once: true });
  }

  // Redraw the drawer without opening it (add-on added from the /cart page).
  function refreshDrawerQuietly(drawer, state) {
    var html = state.sections && state.sections['cart-drawer'];
    var target = drawer.querySelector('#CartDrawer');
    var source = html && parse(html).querySelector('#CartDrawer');
    if (!target || !source) return;
    target.innerHTML = source.innerHTML;
    drawer.classList.remove('is-empty');
    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-kr-xsell-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var drawer = document.querySelector('cart-drawer');
    var inDrawer = !!(drawer && drawer.contains(button));
    var page = pageSections();
    var block = button.closest('.kr-xsell');
    var error = block && block.querySelector('.kr-xsell__error');
    if (error) error.hidden = true;

    var sections = ['cart-icon-bubble'];
    if (drawer) sections.push('cart-drawer');
    page.forEach(function (p) {
      sections.push(p.section);
    });

    // On the /cart page the new product row appears above the offers; keep the
    // offers where the thumb is instead of letting the page jump.
    var anchorTop = !inDrawer && block ? block.getBoundingClientRect().top : null;

    var variantId = Number(button.getAttribute('data-kr-xsell-add'));
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json().then(function (state) {
          if (!response.ok || state.status) throw new Error(state.description || 'add failed');
          return state;
        });
      })
      .then(function (state) {
        page.forEach(function (p) {
          var html = state.sections && state.sections[p.section];
          var target = p.el.querySelector('.js-contents');
          var source = html && parse(html).querySelector('.js-contents');
          if (target && source) target.innerHTML = source.innerHTML;
        });

        if (drawer && inDrawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
          var inner = drawer.querySelector('.drawer__inner');
          if (inner) inner.focus({ preventScroll: true });
          markAdded(drawer, variantId);
          return;
        }

        if (drawer) refreshDrawerQuietly(drawer, state);
        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleHtml = state.sections && state.sections['cart-icon-bubble'];
        var bubbleSource = bubbleHtml && parse(bubbleHtml).querySelector('.shopify-section');
        if (bubble && bubbleSource) bubble.innerHTML = bubbleSource.innerHTML;

        var items = document.getElementById('main-cart-items');
        markAdded(items, variantId);
        var newBlock = items && items.querySelector('.kr-xsell');
        var anchor = newBlock || document.getElementById('main-cart-footer');
        if (anchorTop !== null && anchor) {
          window.scrollBy(0, anchor.getBoundingClientRect().top - anchorTop);
        }
        var name = items && items.querySelector('[data-quantity-variant-id="' + variantId + '"]');
        var row = name && name.closest('.cart-item');
        var link = row && row.querySelector('.cart-item__name');
        if (link) link.focus({ preventScroll: true });
      })
      .catch(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        if (error) error.hidden = false;
      });
  });
})();
